import React, { FC, useMemo } from 'react';

import { FormikSelectField } from '~/@components/FormikFields';
import { LocalizableText } from '~/@components/LocalizableText';
import { useProjectTimeSpentFormikContext } from '~/@views/UserView/ProjectPage/ProjectTimeSpent/ProjectTimeSpentEditForm/ProjectTimeSpentFormik';

export const ProjectTimeSpentLicensePlateSelect: FC<{ disabled?: boolean }> = ({ disabled = false }) => {
    const formik = useProjectTimeSpentFormikContext();

    const items = useMemo(() => formik.values.user?.vehicles.map(v => v.licensePlate) || [], [formik]);

    return (
        <FormikSelectField
            label={<LocalizableText code={'ProjectDocuments.timeSpent.licensePlate'} />}
            name={'licensePlate'}
            formik={formik}
            items={items}
            renderValue={(value: string) => value}
            keyGetter={(value: string) => value}
            disabled={disabled}
            addEmptyOption={false}
        />
    );
};
